<template>
  <div class="template">
    <el-dialog
      title="选择设备"
      top="5vh"
      :visible.sync="dialogVisible"
      width="70%"
      append-to-body
      :before-close="handleClose"
    >
      <div class="dialog-top">
        <el-input
          v-model="searchData.DeviceCode"
          clearable
          placeholder="请输入设备编号/名称"
          style="width: 250px; margin-left: 10px"
        ></el-input>
        <el-input
          v-model="searchData.SupplierName"
          clearable
          placeholder="请输入供应商/生产厂家/维修商名称"
          style="width: 250px; margin-left: 10px"
        ></el-input>
        <SelectData
          style="width: 250px; margin-left: 10px"
          v-model="searchData.DeviceType"
          :disabled="deviceType ? true : false"
          :multiple="false"
          url="/PB/PB_Project/GetDevcieDictionaryMain"
          :option="{ label: 'DicName', Id: 'Id' }"
          :data="{}"
          placeholder="请选择设备分类"
        ></SelectData>
        <SelectData
          style="width: 250px; margin-left: 10px"
          v-model="searchData.BuildingId"
          :multiple="false"
          url="/PB/PB_Project/GetProjectBuildingDataList"
          :option="{ label: 'Name', Id: 'Id' }"
          :data="{}"
          placeholder="请选择安装位置"
        ></SelectData>
        <el-date-picker
          v-model="searchData.purchase_date"
          type="monthrange"
          style="width: 300px; margin-left: 10px"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="安装开始日期"
          end-placeholder="安装结束日期"
          @change="handleDateChange"
        >
        </el-date-picker>

        <SelectData
          v-model="searchData.State"
          :locationOptions="[
            { label: '停机', Id: '0' },
            { label: '开机', Id: '1' },
          ]"
          placeholder="请选择设备状态"
          style="width: 230px; margin-left: 10px"
        ></SelectData>
        <el-button
          type="primary"
          @click="handleSearch"
          style="margin-left: 10px"
          >查询</el-button
        >
      </div>
      <!-- @selection-change="handleSelect" -->
      <div class="dialog-center" v-loading="loading">
        <el-table
          :data="tableData"
          ref="dialogTable"
          style="width: 100%"
          height="calc(100% - 40px)"
          :class="type == 'checkBox' ? 'checkBoxTable' : 'radioTable'"
          @selection-change="handleSelectionChange"
          @select="handleSelect"
          @row-click="handleRowClick"
        >
          <el-table-column label="" width="50" type="selection">
          </el-table-column>
          <el-table-column label="序号" width="50" type="index">
          </el-table-column>

          <el-table-column label="设备编号" align="center" prop="DeviceCode">
          </el-table-column>
          <el-table-column label="设备名称" align="center" prop="device_name">
          </el-table-column>
          <el-table-column label="设备型号" align="center" prop="model_number">
          </el-table-column>
          <el-table-column label="设备规格" align="center" prop="specification">
          </el-table-column>
          <el-table-column
            label="供应商名称"
            align="center"
            prop="SupplierName"
          >
          </el-table-column>
          <el-table-column
            label="生产厂家名称"
            align="center"
            prop="manufacturer"
          >
          </el-table-column>
          <el-table-column label="维修商名称" align="center" prop="maintenance">
          </el-table-column>
          <el-table-column
            label="安装位置"
            align="center"
            prop="InstallationAreaName"
          >
          </el-table-column>

          <!-- <el-table-column label="安装价格" align="center" prop="purchase_price">
        </el-table-column> -->
          <el-table-column label="安装日期" align="center" prop="purchase_date">
            <template slot-scope="scope">
              {{
                scope.row.purchase_date
                  ? moment(scope.row.purchase_date).format('YYYY-MM-DD')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" prop="State">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.State == 0">停机</el-tag>
              <el-tag type="success" v-if="scope.row.State == 1">开机</el-tag>
              <el-tag type="warning" v-if="scope.row.State == 2">故障</el-tag>
              <el-tag type="danger" v-if="scope.row.State == 3">报废</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <div
          style="
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: right;
          "
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.PageIndex"
            :page-sizes="pagination.PageSizes"
            :page-size="pagination.PageRows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
          >
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import SelectData from '@/components/SelectData/SelectData'

export default {
  data() {
    return {
      moment,
      dialogVisible: false,
      templateValue: '',
      searchData: {
        DeviceCode: '',
        InstallationAreaName: '',
        purchase_date: '',
        State: '',
        DeviceType: '',
        BuildingId: '',
        SupplierName: '',
      },
      selectRows: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      tableData: [],

      loading: false,
      selectedRows: [],
    }
  },
  components: { SelectData },
  props: {
    type: { default: 'checkBox', require: false, type: String },
    deviceType: { default: '', require: false, type: String },
  },
  methods: {
    handleDateChange(value) {
      // 无论是否为同一个月，结束日期都应为月末日期
      if (value && value.length === 2) {
        const startDate = moment(value[0])
        const endDate = moment(value[1])
        // 设置开始日期为选择月份的第一天
        const firstDay = startDate.startOf('month').format('YYYY-MM-DD')
        // 设置结束日期为选择月份的最后一天
        const lastDay = endDate.endOf('month').format('YYYY-MM-DD')
        this.$set(this.searchData, 'purchase_date', [firstDay, lastDay])
      }
    },
    confirm() {
      console.log(this.selectRows, '')
      if (this.selectRows.length <= 0) {
        return this.$notify.warning('请选择')
      }
      this.$emit('select', [...this.selectRows])
      this.dialogVisible = false
    },
    handleRowClick(row) {
      if (this.type == 'checkBox') {
        this.$refs.dialogTable.toggleRowSelection(row)
        return
      }
      this.$refs.dialogTable.clearSelection()
      this.$refs.dialogTable.toggleRowSelection(row)
      this.selectRows = [row]
    },
    handleSelect(selection, row) {
      console.log(selection, row)

      if (this.type == 'checkBox') {
        this.selectRows = selection
        return
      }
      this.$refs.dialogTable.clearSelection()
      this.$refs.dialogTable.toggleRowSelection(row)
      this.selectRows = [row]
    },
    handleSelectionChange(val) {
      console.log(val)
      if (this.type == 'checkBox') {
        this.selectRows = val
        return
      }
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/PB/PB_Project/GetProjectDevceList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: [
            {
              Condition: 'DeviceCode',
              Keyword: this.searchData.DeviceCode,
            },
            {
              Condition: 'InstallationAreaName',
              Keyword: this.searchData.InstallationAreaName,
            },
            {
              Condition: 'State',
              Keyword: this.searchData.State,
            },
            {
              Condition: 'purchase_date',
              Keyword:
                this.searchData.purchase_date?.length > 0
                  ? this.searchData.purchase_date.join(',')
                  : '',
            },
            {
              Condition: 'DeviceType',
              Keyword: this.deviceType || this.searchData.DeviceType,
            },
            {
              Condition: 'SupplierName',
              Keyword: this.searchData.SupplierName,
            },
            {
              Condition: 'BuildingId',
              Keyword: this.searchData.BuildingId,
            },
          ],
        })
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
          this.$nextTick(() => {
            this.$refs.dialogTable.clearSelection()
          })
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    openDialog() {
      this.dialogVisible = true

      this.searchData = {
        DeviceCode: '',
        InstallationAreaName: '',
        purchase_date: '',
        State: '',
        DeviceType: this.deviceType || '',
        BuildingId: '',
      }
      this.handleSearch()
    },
    handleClose() {
      this.dialogVisible = false
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {
    deviceType(newValue) {
      this.searchData.DeviceType = newValue
    },
    value(newValue) {
      this.templateValue = newValue
    },
  },
}
</script>
<style lang="scss" scoped>
.template {
  width: 100%;
}
::v-deep .el-dialog__body {
  padding: 20px;
  padding-top: 10px;
}
::v-deep .el-dialog__title {
  font-weight: bold;
}
.dialog-top {
  height: 70px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.dialog-center {
  height: calc(70vh - 70px);
}
::v-deep
  .radioTable
  .el-table__header-wrapper
  .el-table-column--selection
  .cell {
  display: none;
}
</style>
